module.exports = "../images/icons/mail-notification-map-icon.png";